import { gql, type TypedDocumentNode } from "@apollo/client";

export type EmailPreview = {
  subject: string;
  html: string;
};

export type EmployerChangeAlertEmailPreviewVariables = {
  personId: string;
  facilityId: string;
  jobTitle: string;
  startedOn: string;
  endedOn?: string | null;
  careerConsultantId?: string | null;
};

export interface EmployerChangeAlertEmailPreviewQueryResponse {
  employerChangeAlertEmailPreview: EmailPreview;
}

export interface EmployerChangeAlertEmailPreviewQueryVariables {
  personId: string;
  facilityId: string;
  jobTitle: string;
  startedOn: string;
  endedOn?: string | null;
  careerConsultantId?: string | null;
}

export const EMPLOYER_CHANGE_ALERT_EMAIL_PREVIEW_QUERY: TypedDocumentNode<
  EmployerChangeAlertEmailPreviewQueryResponse,
  EmployerChangeAlertEmailPreviewQueryVariables
> = gql`
  query EmployerChangeAlertEmailPreview(
    $personId: ID!
    $facilityId: ID!
    $jobTitle: String!
    $startedOn: ISO8601Date!
    $endedOn: ISO8601Date
    $careerConsultantId: ID
  ) {
    employerChangeAlertEmailPreview(
      personId: $personId
      facilityId: $facilityId
      jobTitle: $jobTitle
      startedOn: $startedOn
      endedOn: $endedOn
      careerConsultantId: $careerConsultantId
    ) {
      subject
      html
    }
  }
`;
